// extracted by mini-css-extract-plugin
module.exports = {"pc-whiteboard":"pc-whiteboard___3rov9","loading":"loading___2Abhb"};